document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-testimonials-track]').forEach(initTestimonialsTrack);
});

function initTestimonialsTrack(track) {
  const viewport = track.closest('.testimonials__viewport');
  const originalCards = Array.from(track.children);

  if (originalCards.length < 3) return;

  const total = originalCards.length;

  const PAUSE_MS = 2200;
  const TRANSITION_MS = 650;

  let index = 0;
  let timer = null;
  let paused = false;
  let isAnimating = false;

  /*
   * Duplicate the cards for seamless looping.
   */
  originalCards.forEach(function (card) {
    track.appendChild(card.cloneNode(true));
  });

  const allCards = Array.from(track.children);

  function getTargetOffset() {
    const firstCard = allCards[0];
    const targetCard = allCards[index];

    if (!firstCard || !targetCard) return 0;

    return targetCard.offsetTop - firstCard.offsetTop;
  }

  function moveTrack(animate) {
    const activeCard = allCards[index + 1];

    if (!activeCard || !viewport) return;

    const viewportHeight = viewport.clientHeight;
    const cardCenter = activeCard.offsetTop + (activeCard.offsetHeight / 2);
    const targetOffset = cardCenter - (viewportHeight / 2);

    track.style.transition = animate
      ? `transform ${TRANSITION_MS}ms cubic-bezier(0.4, 0, 0.2, 1)`
      : 'none';

    track.style.transform = `translateY(-${targetOffset}px)`;
  }

  function setCardStates() {
    allCards.forEach(function (card) {
      card.classList.remove(
        'testimonial-card--previous',
        'testimonial-card--active',
        'testimonial-card--next',
        'testimonial-card--hidden'
      );

      card.classList.add('testimonial-card--hidden');
    });

    /*
     * Physical cards visible at any point.
     */
    const previous = allCards[index];
    const active = allCards[index + 1];
    const next = allCards[index + 2];

    if (previous) {
      previous.classList.remove('testimonial-card--hidden');
      previous.classList.add('testimonial-card--previous');
    }

    if (active) {
      active.classList.remove('testimonial-card--hidden');
      active.classList.add('testimonial-card--active');
    }

    if (next) {
      next.classList.remove('testimonial-card--hidden');
      next.classList.add('testimonial-card--next');
    }
  }

  function step() {
    if (paused || isAnimating) {
      timer = setTimeout(step, PAUSE_MS);
      return;
    }

    isAnimating = true;

    index += 1;

    setCardStates();
    moveTrack(true);

    /*
     * Once we've moved through the original set,
     * silently reset to the beginning.
     */
    if (index >= total) {
      setTimeout(function () {
        index = 0;

        track.style.transition = 'none';
        track.style.transform = 'translateY(0px)';

        void track.offsetHeight;

        setCardStates();

        isAnimating = false;
      }, TRANSITION_MS);
    } else {
      setTimeout(function () {
        isAnimating = false;
      }, TRANSITION_MS);
    }

    timer = setTimeout(
      step,
      PAUSE_MS + TRANSITION_MS
    );
  }

  function pause() {
    paused = true;

    if (viewport) {
      viewport.classList.add('is-paused');
    }
  }

  function resume() {
    paused = false;

    if (viewport) {
      viewport.classList.remove('is-paused');
    }
  }

  /*
   * Initial state.
   */
  setCardStates();
  moveTrack(false);

  window.addEventListener('resize', function () {
    moveTrack(false);
  });

  const prefersReducedMotion =
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!prefersReducedMotion) {
    timer = setTimeout(step, PAUSE_MS);
  }
}